<template>
    <PrimaryButton class="upload-button green" @click="onClick" :text="text" :icon="icon" :size="size">
        <template slot="footer">
            <Loading v-if="isUploading" :absolute="true" class="upload-button-loading">
                <div class="upload-button-loading-content">
                  <Progress :progress="this.progress"/>
                  <span class="upload-button-loading-content-text">{{$t('upload.file.title')}}</span>
                </div>
            </Loading>
            <form ref="form">
                <input ref="inputFile" type="file" class="" id="file" :accept="accept" @change="onInputFileChange" />
            </form>
        </template>
    </PrimaryButton>
</template>

<i18n>
{
    "en": {
        "upload": {
            "file": {
                "title": "Uploading your file... please wait."
            }
        }
    },
    "es": {
        "upload": {
            "file": {
                "title": "Cargando su archivo... por favor espere."
            }
        }
    },
    "fr": {
        "upload": {
            "file": {
                "title": "Téléchargement de votre fichier... veuillez patienter."
            }
        }
    },
    "pt": {
        "upload": {
            "file": {
                "title": "Carregando o seu ficheiro... aguarde, por favor."
            }
        }
    },
    "de": {
        "upload": {
            "file": {
                "title": "Hochladen Ihrer Datei... bitte warten."
            }
        }
    },
    "nl": {
        "upload": {
            "file": {
                "title": "Upload uw bestand... wacht even."
            }
        }
    }
}
</i18n>

<script>
import PrimaryButton from './PrimaryButton.vue'
import Loading from '@/components/v3/loading/Loading.vue'
import Progress from '@/components/v3/progress/Progress.vue'

import {uploadServices} from '@/modules/commons/services/UploadServices'

export default {
    components: {
        PrimaryButton,
        Loading,
        Progress
    },
    props: {
        text: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        size: {
            type: String,
            default: 'normal'
        },
        accept: {
            type: String,
            default: '*'
        },
        autoUploadOnClick: {
            type: Boolean,
            default: true
        },
        customData: {
            type: Object,
            default () {
                return null
            }
        }
    },
    data () {
        return {
            progress: 0,
            isUploading: false
        }
    },
    methods: {
        onClick (e) {
            this.$emit('click', e, this.customData)
            // trigger upload file dialog
            this.$refs.inputFile.click()
            // this.isUploading = true
            // this.progress = Math.random()
        },
        onInputFileChange (e) {
          const files = e.target.files || e.dataTransfer.files
          if (files && files[0]) this.processFile(files[0])
        },
        processFile (file) {
            console.log('processFile', file)
            if (this.autoUploadOnClick) {
                this.uploadData(file)
            }
            // } else {
            //     this.$emit('data', file, this.customData)
            // }
            this.$emit('file', file, this.customData)
            this.$refs.form.reset()
        },
        uploadData(file) {
            console.log('uploadData', file)
            this.isUploading = true
            this.progress = 0
            let config = {
                onUploadProgress: this.onUploadProgress
            }
            uploadServices.uploadFile(file, config).then(data => {
                console.log('cv upload SUCCESS', data)
                this.isUploading = false
                this.progress = 100
                this.$emit('complete', data, file.name, this.customData)
                // this.serverFileName = data
                // this.localFileName = file.name
                this.$emit('change', file.name, this.customData)
                this.$emit('final', this.customData)
            }).catch(error => {
                console.log('cv upload ERROR', error)
                this.$emit('error', error, this.customData)
                this.$emit('final', this.customData)
                this.isUploading = false
                this.$showNotification(
                    this.$t('commons.uploadFileError'),
                    'error'
                )
            })
          },
          onUploadProgress(e) {
              if (!this.isUploading) return
              this.progress = e.loaded / e.total
              console.log('progress', this.progress)
          },
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.upload-button

    input
        display none

.upload-button-loading

    .upload-button-loading-content
        display flex
        flex-direction column
        width 320px

        .upload-button-loading-content-text
            font-weight 400
            font-size 16px
            margin-top 4px
            margin-left 4px
            align-self flex-start
            color black

</style>



// WEBPACK FOOTER //
// src/components/v3/buttons/UploadButton.vue